<!-- Bipartite graph of credit and loyalty cards -->
<script>
    import { c2l_datapoints } from './store.js';
    $: datapoints = $c2l_datapoints

    let w = 350
    let h = 600

    const get_index_cc = function(cc) {
        return creditcard_numbers.filter(d => { return d.number == cc})[0].index
    }
    const get_index_lc = function(lc) {
        return loyaltycard_numbers.filter(d => { return d.number == lc})[0].index
    }

    $: tmp_creditcard_numbers = [...new Set(datapoints.map(d => {return d.last4ccnum}))]
    $: tmp_loyaltycard_numbers = [...new Set(datapoints.map(d => {return d.loyalty}))]
    let creditcard_numbers = []
    $: {
        creditcard_numbers = []
        tmp_creditcard_numbers.forEach((d,idx) => {
            creditcard_numbers = [...creditcard_numbers, {number: d, index: idx}]
        })
    }
    let loyaltycard_numbers = []
    $: {
        loyaltycard_numbers = []
        tmp_loyaltycard_numbers.forEach((d,idx) => {
            loyaltycard_numbers = [...loyaltycard_numbers, {number: d, index: idx}]
        })
    }

    let selected_link = undefined;
    let mouse_x, mouse_y;

    const setMousePosition = function(event) {
        mouse_x = event.clientX;
        mouse_y = event.clientY;
    }
</script>

<style>
    svg {
        background-color: whitesmoke;
        padding: 5px;
    }
    circle {
        fill: steelblue;
    }
    line {
        stroke: black;
    }
    text, td {
        font-size: x-small;
    }
    td {
        vertical-align: top;
    }
</style>

<h2>Credit vs loyalty cards</h2>
<table>
<tr>
<td>
<svg width={w} height={h}>
    <text x=50 y=20 text-anchor="middle" style="font-size: large;">Credit card</text>
    <text x=250 y=20 text-anchor="middle" style="font-size: large;">Loyalty card</text>

    <g transform="translate(0,30)">
        {#each datapoints as link}
            <line x1=50 y1={10+get_index_cc(link.last4ccnum)*10}
                x2=250 y2={10+get_index_lc(link.loyalty)*10} 
                style="stroke-width:{link.count/6}; stroke-opacity:{link.count/28}"
                on:mouseover={(event) => {selected_link = link; setMousePosition(event)}}
                on:mouseout={() => {selected_link = undefined}}/>
        {/each}

        {#each creditcard_numbers as cc}
            <text x=45 y={10+cc.index*10} dominant-baseline="middle" text-anchor="end">{cc.number}</text>
            <circle cx=50 cy={10+cc.index*10} r=4>
                <title>{cc.number}</title>
            </circle>
        {/each}

        {#each loyaltycard_numbers as lc}
            <text x=255 y={10+lc.index*10} dominant-baseline="middle" text-anchor="start">{lc.number}</text>
            <circle cx=250 cy={10+lc.index*10} r=4>
                <title>{lc.number}</title>
            </circle>
        {/each}
    </g>
</svg>
</td>
<td>
    Details for this link:<br/>
    <table>
    {#if selected_link}
        <tr>
            <th>Location</th>
            <th>Price</th>
            <th>Day</th>
        </tr>
        {#each selected_link.data as d}
            <tr>
                <td>{d.location}</td><td>{d.price}</td><td>{d.day}</td>
            </tr>
        {/each}
    {/if}
    </table>
</td>
</tr>
</table>

